import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Platform } from '@ionic/angular/standalone';
import { IDEAStorageService, IDEATranslationsService } from '@idea-ionic/common';

import { AppService } from './common/app.service';

import { Languages } from '@models/section.model';

export const initGuard: CanActivateFn = async (): Promise<boolean> => {
  const platform = inject(Platform);
  const storage = inject(IDEAStorageService);
  const t = inject(IDEATranslationsService);
  // const appStatus = inject(IDEAAppStatusService);
  const app = inject(AppService);

  if (app.initReady) return true;

  await platform.ready();
  await storage.ready();

  await t.init(Object.values(Languages), Languages.EN);
  // `use` only resolves when it actually applies a language, so it must be forced:
  // without this the guard never returns for a browser already set to English.
  await t.use(Languages.EN, true);

  // await appStatus.check();

  app.initReady = true;

  return true;
};
